<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">{{ title }} </v-toolbar-title>
          <v-spacer />
          <v-btn depressed rounded color="green" dark :to="{ name: 'configuracao.pessoa' }">
            <v-icon>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card outlined>
      <PessoaForm />
    </v-card>
  </div>
</template>

<script>
import PessoaForm from './Form.vue';

export default {
  name: 'PessoaCriar',
  components: { PessoaForm },
  metaInfo: {
    title: 'Adicionar Pessoa',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Adicionar Pessoa',
  }),
};
</script>

<style></style>
